import { Search, X } from "lucide-react";

interface StatusOption {
  value: string;
  label: string;
}

interface Props {
  search: string;
  onSearchChange: (v: string) => void;
  searchPlaceholder?: string;

  status: string;
  onStatusChange: (v: string) => void;
  statusOptions: StatusOption[];

  /** Si está definido, muestra select de país (ISO alpha-2) */
  country?: string;
  onCountryChange?: (v: string) => void;
  countryOptions?: StatusOption[];

  /** Render slot para botones extra (ej: exportar CSV) */
  rightSlot?: React.ReactNode;
}

export function FiltersBar({
  search,
  onSearchChange,
  searchPlaceholder = "Buscar…",
  status,
  onStatusChange,
  statusOptions,
  country,
  onCountryChange,
  countryOptions,
  rightSlot,
}: Props) {
  return (
    <div className="flex flex-wrap items-center gap-2 mb-4">
      <div className="relative flex-1 min-w-[200px]">
        <Search
          size={14}
          className="absolute left-3 top-1/2 -translate-y-1/2 text-fg-subtle pointer-events-none"
        />
        <input
          type="search"
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder={searchPlaceholder}
          className="nx-input pl-8 pr-8"
        />
        {search && (
          <button
            onClick={() => onSearchChange("")}
            className="absolute right-2 top-1/2 -translate-y-1/2 text-fg-subtle hover:text-fg"
            aria-label="Limpiar búsqueda"
          >
            <X size={14} />
          </button>
        )}
      </div>

      <select
        value={status}
        onChange={(e) => onStatusChange(e.target.value)}
        className="nx-input w-auto"
      >
        <option value="">Todos los estados</option>
        {statusOptions.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>

      {countryOptions && onCountryChange && (
        <select
          value={country ?? ""}
          onChange={(e) => onCountryChange(e.target.value)}
          className="nx-input w-auto"
        >
          <option value="">Todos los países</option>
          {countryOptions.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
      )}

      {rightSlot}
    </div>
  );
}
